import { render, staticRenderFns } from "./SaveSolutionModal.vue?vue&type=template&id=679b4904&scoped=true"
import script from "./SaveSolutionModal.vue?vue&type=script&lang=js"
export * from "./SaveSolutionModal.vue?vue&type=script&lang=js"
import style0 from "./SaveSolutionModal.vue?vue&type=style&index=0&id=679b4904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679b4904",
  null
  
)

export default component.exports